import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
import user from "@/store/modules/user";
import client from "@/store/modules/client";
import { http } from "@/config/http";
import { SnotifyPosition, SnotifyStyle } from 'vue-snotify';
import router from "@/routes/router";

const namespaced = true;
const state = {
  sidebarShow: false,
  sidebarMinimize: false,
  activeMealTypeBtn: "BF",
  spinerColor: "#8B2326",
  spinerLoader: "bars",
  activeClaimData: [],
  tb_step : 0
}

const mutations = {
  set(state, [variable, value]) {
    state[variable] = value
  },
  handleExceptions(state, error) {
    if (error.response) {
      if (error.response.data) {
        if (error.response.data.code != 422) {

          if (error.response.data.error || error.response.data.message) {
            this.commit(
              "showAlert",
              {
                title: "Error!",
                msg: error.response.data.message ? error.response.data.message : error.response.data.error.message,
                type: "error",
                position: "centerTop"
              },
              { root: true }
            );
          }

          if (error.response.data.message == "Unauthorized") {
            router.push({ name: 'Login' });
          }
        }
      }
      else {
        this.commit(
          "showAlert",
          {
            title: "Error!",
            msg: "Oops..something went wrong.",
            type: "error",
            position: "centerTop"
          },
          { root: true }
        );
      }
    } else {
      this.commit(
        "showAlert",
        {
          title: "Error!",
          msg: "Oops..something went wrong.Please check your internet connectivity",
          type: "error",
          position: "centerTop"
        },
        { root: true }
      );
    }
  },
  showAlert: (state, data) => {
    let type = '';
    let position = '';
    switch (data.type) {
      case "error": {
        type = SnotifyStyle.error;
        break;
      }
      case "success": {
        type = SnotifyStyle.success;
        break;
      }
      case "info": {
        type = SnotifyStyle.info;
        break;
      }
      case "warning": {
        type = SnotifyStyle.warning;
        break;
      }
      case "async": {
        type = SnotifyStyle.async;
        break;
      }
      case "confirm": {
        type = SnotifyStyle.confirm;
        break;
      }
      case "prompt": {
        type = SnotifyStyle.prompt;
        break;
      }

      default: {
        type = SnotifyStyle.simple;
        break;
      }
    }
    switch (data.position) {
      case "leftTop": {
        position = SnotifyPosition.leftTop;
        break;
      }
      case "leftCenter": {
        position = SnotifyPosition.leftCenter;
        break;
      }
      case "leftBottom": {
        position = SnotifyPosition.leftBottom;
        break;
      }
      case "rightTop": {
        position = SnotifyPosition.rightTop;
        break;
      }
      case "rightCenter": {
        position = SnotifyPosition.rightCenter;
        break;
      }
      case "rightBottom": {
        position = SnotifyPosition.rightBottom;
        break;
      }
      case "centerCenter": {
        position = SnotifyPosition.centerCenter;
        break;
      }
      case "centerTop": {
        position = SnotifyPosition.centerTop;
        break;
      }
      case "centerBottom": {
        position = SnotifyPosition.centerBottom;
        break;
      }

      default: {
        position = SnotifyPosition.rightTop;
        break;
      }
    }
    Vue.$snotify.clear();

    Vue.$snotify.create({
      title: data.title,
      body: data.msg,
      config: {
        position: position,
        type: type,
        timeout: 2000,
        closeOnClick: true,
        pauseOnHover: true,
      }
    })
  },
}

const actions = {
}

export default new Vuex.Store({
  namespaced,
  state,
  mutations,
  actions,
  modules: {
    user,
    client
  },
})